// @flow
import React from 'react';
import classNames from 'classnames';
import IconLeftArrowBlack from 'assets/images/leftb.png';
import IconRightArrowBlack from 'assets/images/rightb.png';
import IconLeftArrowWhite from 'assets/images/leftw.png';
import IconRightArrowWhite from 'assets/images/rightw.png';
import './styles.scss';

type Props = {
  currentIndex: number,
  total: number,
  onPreviousClick: () => void,
  onNextClick: () => void,
  theme: string,
  mode?: 'pages' | 'slider',
  className?: string,
};
export const PaginationControl = (props: Props) => {
  const {
    className,
    theme,
    currentIndex,
    total,
    mode = 'pages',
    onNextClick,
    onPreviousClick,
  } = props;

  if (total === 0) {
    return null;
  }

  const containerClassName = classNames('pagination-control', className, {
    dark: theme === 'dark-theme',
    light: theme === 'light-theme',
  });

  const leftArrowIcon =
    theme === 'dark-theme' ? IconLeftArrowWhite : IconLeftArrowBlack;
  const rightArrowIcon =
    theme === 'dark-theme' ? IconRightArrowWhite : IconRightArrowBlack;

  const renderPagination = () => {
    if (mode === 'pages') {
      return (
        <>
          <strong>{currentIndex}</strong>
          <span className={'separator'} />
          {total}
        </>
      );
    }

    const sliderSectionWidth = `${100 / total}%`;
    const activeIndex = currentIndex - 1;

    return (
      <div className={'pagination-slider'}>
        {Array(total)
          .fill(0)
          .map((value, idx) => {
            const sliderSectionClass = idx === activeIndex ? 'active' : '';
            return (
              <div
                key={idx}
                className={sliderSectionClass}
                style={{ width: sliderSectionWidth }}
              />
            );
          })}
      </div>
    );
  };

  return (
    <div className={containerClassName}>
      <button className={'btn-left'} onClick={onPreviousClick}>
        <img src={leftArrowIcon} alt={'Left Arrow'} />
      </button>
      <div className={'pagination-values'}>{renderPagination()}</div>
      <button className={'btn-right'} onClick={onNextClick}>
        <img src={rightArrowIcon} alt={'Right Arrow'} />
      </button>
    </div>
  );
};
